import './Maintenance.style.scss';
import logo from 'assets/images/logo.png';
import homeImg from 'assets/images/homeImg.png';
import { useTranslation } from 'react-i18next';

const Maintenance = () => {
  const { t } = useTranslation();
  return (
    <div className="Home">
      <img className="home_main_logo" src={logo} alt="main logo assolia" />
      <div className="home_content">
        <img className="home_logo" src={homeImg} alt="logo assolia" />
        <h1 className="title__maintenance">{t('maintenance.title')}</h1>
        <p>{t('maintenance.backSoon')}</p>
        <p className="contact-info">
          {t('maintenance.contactInfo')}{' '}
          <a href="mailto:contact@assolia.com">{t('maintenance.contactLink')}</a>.
        </p>
        <p>{t('maintenance.team')}</p>
      </div>
    </div>
  );
};

export default Maintenance;
